import { createSlice } from "@reduxjs/toolkit";

const storedUser = localStorage.getItem("UserId");
const parsedUser = storedUser ? JSON.parse(storedUser) : null;

const initialState = {
  userId: parsedUser?.id || null, // ✅ safely extract the ID
  professionalId: null,
  preferenceId: null,
  username:null,
  zodiacId:null
};

const userSlice = createSlice({ 
  name: "user",
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
      // ✅ also sync back to localStorage\
      const userData = {
        id: action.payload,
        timestamp: new Date().toISOString(),
      };
      localStorage.setItem("UserId", JSON.stringify(userData));
    },
    setUsername:(state,action)=>{
      state.username=action.payload;
    },
    setProfessionalId: (state, action) => {
      state.professionalId = action.payload;
    },
    setPreferenceId: (state, action) => {
      state.preferenceId = action.payload;
    },
    setZodiacId:(state,action)=>{
      state.zodiacId =action.payload;
    },
    clearUserState: (state) => {
      state.userId = null;
      state.professionalId = null;
      state.preferenceId = null;
      state.zodiacId=null;
      state.username = null;
      localStorage.removeItem("UserId");
    },
  },
});

export const {
  setUserId,
  setUsername,
  setProfessionalId,
  setPreferenceId,
  setZodiacId,
  clearUserState,
} = userSlice.actions;

export default userSlice.reducer;
